import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Main Components
import { ListBuilderComponent } from './components/main/list-builder/list-builder.component';
import { OptionsComponent } from './components/main/options/options.component';
// Shared Components
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { DropdownComponent } from './components/shared/dropdown/dropdown.component';
// Parent Component
import { MergeAttachmentsComponent } from './merge-attachments.component';
// Attachments Routing Module
import { RoutingModule } from './modules/routing/routing.module';
// Shared Services
import { ModalComponent } from './components/shared/modal/modal.component';
import { ModalHeaderComponent } from './components/shared/modal/modal-header/modal-header.component';
import { ModalContentComponent } from './components/shared/modal/modal-content/modal-content.component';
import { ModalFooterComponent } from './components/shared/modal/modal-footer/modal-footer.component';
import { SharedComponentsModule } from '../../../SharedComponent/shared-components.module';
@NgModule({
    imports: [CommonModule, RoutingModule, FormsModule, SharedComponentsModule],
    providers: [],
    declarations: [
        ListBuilderComponent,
        OptionsComponent,
        NavbarComponent,
        MergeAttachmentsComponent,
        DropdownComponent,
        ModalComponent,
        ModalHeaderComponent,
        ModalContentComponent,
        ModalFooterComponent
    ],
    exports: [
        MergeAttachmentsComponent,
        ModalComponent,
        ModalHeaderComponent,
        ModalContentComponent,
        ModalFooterComponent
    ]
})
export class MergeAttachmentsModule {}
